
namespace Matrix.Indexation {

    @Serenity.Decorators.registerClass()
    export class FactIndexConstituentRorGrid extends SiteEntityGrid<FactIndexConstituentRorRow, any> {
        protected getColumnsKey() { return FactIndexConstituentRorColumns.columnsKey; }
        protected getDialogType() { return FactIndexConstituentRorDialog; }
        protected getIdProperty() { return FactIndexConstituentRorRow.idProperty; }
        protected getInsertPermission() { return FactIndexConstituentRorRow.insertPermission; }
        protected getLocalTextPrefix() { return FactIndexConstituentRorRow.localTextPrefix; }
        protected getService() { return FactIndexConstituentRorService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}